import React from 'react'
import { Col, Row } from 'reactstrap'

const InfluenzaWeeklyRates = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding10rem1 right-padding10rem1 pt-md-5 pt-4 pb-md-4'>
            <div className='pb-4'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    Weekly Detection Rates
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>
            <div className=''>
                <Row className='flex-center'>
                    <Col xs='12' sm='6' md='5' lg='3' className='pb-md-0 pb-4'>
                        <div className=''>
                            <img src='influenza-testing/Influenza-Testing-stats1.1.png' alt='Weekly Results' className='img-w' width='100%' height='290px' />
                        </div>
                    </Col>
                    <Col xs='12' sm='6' md='5' lg='3' className='pb-md-0 pb-4'>
                        <div className=''>
                            <img src='influenza-testing/Influenza-Testing-stats1.2.png' alt='Weekly Results' className='img-w' width='100%' height='290px'/>
                        </div>
                    </Col>
                    <Col md='10' lg='6' className='pb-md-0 pb-4 pt-md-4 pt-lg-0'>
                        <div className=''>
                            <img src='influenza-testing/Influenza-Testing-stats1.3.png' alt='Weekly Results' className='img-w'  width='100%' height='290px'/>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='px-md-5 py-md-5 py-3'>
            <div className='pb-4 pt-md-4'>
                <div className='fs-ss-22-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    High Activity {`(>3%)`}
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>
            <div className='pt-3'>
                <Row className='flex-center'>
                    <Col md='6' className=''>
                        <div className='flex-center pb-md-0 pb-4'>
                            <img src='influenza-testing/Influenza-Testing-stats2.1.png' alt='Weekly Results' className='img-w8' width='' height='' />
                        </div>
                    </Col>
                    <Col md='6' className=''>
                        <div className='flex-center pt-md-0 pt-4'>
                            <img src='influenza-testing/Influenza-Testing-stats2.2.png' alt='Weekly Results' className='img-w8' width='' height=''/>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <div className='px-md-5 py-md-4 py-4'>
            <div className='pb-4 pt-1'>
                <div className='fs-ss-22-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    Medium Activity (1%-3%)
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>
            <div className='pt-3 pb-md-3 pb-4'>
                <Row className='flex-center'>
                    <Col md='6' className=''>
                        <div className='flex-center pb-md-0 pb-4'>
                            <img src='influenza-testing/Influenza-Testing-stats2.3.png' alt='Weekly Results' className='img-w8' width='' height='' />
                        </div>
                    </Col>
                    <Col md='6' className=''>
                        <div className='flex-center pt-md-0 pt-4'>
                            <img src='influenza-testing/Influenza-Testing-stats2.4.png' alt='Weekly Results' className='img-w8' width='' height=''/>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        </div>
    </div>
  )
}

export default InfluenzaWeeklyRates